<script setup lang="ts">
import { SolButton } from '@solfacil/girassol'
import { useI18n } from 'vue-i18n'
import { useImpersonateStore } from '~/store/impersonate'

const impersonateStore = useImpersonateStore()
const { t } = useI18n()

function handleOpenImpersonateModal() {
  impersonateStore.toggleImpersonateModal()
}
</script>

<template>
  <div class="projects-in-progress-not-impersonate">
    <div class="not-impersonate-content">
      <img
        src="/images/not-impersonate-overview.svg"
        alt="Not impersonating"
        class="not-impersonate-image"
      >
      <div class="not-impersonate-text">
        <h3 class="not-impersonate-title">
          {{ t('overview.projects_in_progress.not_impersonate.title') }}
        </h3>
        <p class="not-impersonate-subtitle">
          {{ t('overview.projects_in_progress.not_impersonate.subtitle') }}
        </p>
      </div>
      <SolButton
        id="view-as-partner"
        @click="handleOpenImpersonateModal"
      >
        {{ t('overview.projects_in_progress.not_impersonate.view_as_partner') }}
      </SolButton>
    </div>
  </div>
</template>

<style scoped lang="scss">
.projects-in-progress-not-impersonate {
  @apply flex items-center justify-center py-8;

  .not-impersonate-content {
    @apply flex flex-col items-center gap-6 max-w-[550px] text-center;

    .not-impersonate-image {
      @apply w-full max-w-[105px] h-auto;
    }

    .not-impersonate-text {
      @apply flex flex-col gap-2;

      .not-impersonate-title {
        @apply fonts-heading-h4 text-neutral-low-pure;
      }

      .not-impersonate-subtitle {
        @apply fonts-body-large-regular text-neutral-low-light;
      }
    }
  }
}
</style>
